import React from 'react';
import { FooterButtonWithRadius } from "../../CEF/Common/FooterButton";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, SubmitButton } from '@applyboard/ui-components';
import { Flex } from '@applyboard/crystal-ui';
import { QuestionSetHeading } from "../../Wizards/QuestionSetHeading";
import Progress from "../../Wizards/Progress";
export var PreferencesContainer = function PreferencesContainer(_ref) {
  var children = _ref.children,
    skipButton = _ref.skipButton,
    _submitButton = _ref.submitButton,
    submitLabel = _ref.submitLabel;
  var submitButton = _submitButton !== null && _submitButton !== void 0 ? _submitButton : /*#__PURE__*/React.createElement(SubmitButton, {
    fullWidth: true,
    as: FooterButtonWithRadius,
    type: "submit"
  }, submitLabel ? submitLabel : 'Next');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    px: 5
  }, /*#__PURE__*/React.createElement(QuestionSetHeading, {
    text: "Preferences"
  }), /*#__PURE__*/React.createElement(Progress, null), /*#__PURE__*/React.createElement(Box, null, children)), skipButton ? /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    align: "center",
    justify: "center",
    gap: 2
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    grow: 1
  }, /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, skipButton)), /*#__PURE__*/React.createElement(Flex.Item, {
    grow: 1
  }, /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, submitButton))) : /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, submitButton));
};